module.exports = __webpack_public_path__ + "img/newbg.90d5961e.png";